module.exports = __webpack_public_path__ + "static/img/yangan3.5c03b581.png";